
import { AnnotationConstant } from "../../Constants/AnnotationConstants";
const { ActionTypes } = AnnotationConstant;
import { TriangleModelInfo } from "../../Models/AnnotationModels/TriangleModelInfo";

const triangles = []

const triangleReducer = (state = triangles, action) => {

    switch (action.type) {
        case ActionTypes.INIT_TRIANGLE_COLLECTION:
            return action.EllipseCollection;
        case ActionTypes.HANDLE_TRIANGLE_CLICK_SUCCESS:
            return [...state, action.triangle]
        case ActionTypes.HANDLE_TRIANGLE_DRAW_SUCCESS:
            return state.map((item) => (item.id === action.triangle.id) ? action.triangle : item)
        case ActionTypes.HANDLE_TRIANGLE_SAVE_ID_SUCCESS:
            return action.triangles
        case ActionTypes.HANDLE_TRIANGLE_TRANSFORM_SUCCESS:
            return state.map((item) => (item.id === action.triangle.id) ? action.triangle : item)
        case ActionTypes.HANDLE_REMOVE_TRIANGLE_DRAW:
            return state.filter((item) => item.id !== action.annotSelectedId)
        case ActionTypes.REMOVE_DELETED_ANNOTATIONS:
            return state.map((item) => action.annotDeletedId.includes(item.id) ? Object.assign(new TriangleModelInfo, { ...item, isDeleted: true }) : item)
        case ActionTypes.RESTORE_DELETED_ANNOTATIONS:
            return state.map((item) => action.annotDeletedId.includes(item.id) ? Object.assign(new TriangleModelInfo, { ...item, isDeleted: false }) : item)
        case ActionTypes.CLEAR_ANNOTATIONS:
            return [];
        default:
            return state
    }
}

export default triangleReducer;